import { InfoTooltip } from '@/components/poppers/Tooltip/InfoTooltip';

interface RecipientNotesBadgeProps {
  notes: string;
}

export function RecipientNotesBadge({ notes }: RecipientNotesBadgeProps) {
  return <InfoTooltip title={notes} placement="top" />;
}
